import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PARTNER_GET_APPLICATION_QUESTIONS_BY_ID } from 'api/actionTypes';

export default async function getApplicationQuestionsById(
  { state, apiClient },
  { partnerId, forceRefresh = false },
) {
  typeCheck('partnerId::PositiveNumber', partnerId);

  const currentQuestionsStatePath = ['partners', 'applicationQuestionsById', partnerId];
  if (state.get(currentQuestionsStatePath) && !forceRefresh) {
    return state.get(currentQuestionsStatePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_APPLICATION_QUESTIONS_BY_ID,
    queryId: partnerId,
    state: state,
    payload: {
      partnerId,
    },
    onSuccess(partnerApplicationQuestions) {
      if (partnerApplicationQuestions) {
        state.set(currentQuestionsStatePath, partnerApplicationQuestions);
      }
      return partnerApplicationQuestions;
    },
  });
}
